import { DigitMode } from '../../../BetLotto.types'
import { useTranslation } from 'react-i18next'
import SearchAndRotation from '../SearchAndRotation/SearchAndRotation'
import useSearchAndRotation from '../SearchAndRotation/useSearchAndRotation'
import SelectBetNumber from '../SelectBetNumber/SelectBetNumber'
import { BasePanelProps } from '../../PanelSelection.types'

const RunningPanel: React.FC<BasePanelProps> = ({
  activeBetType,
  betList,
  addLottoListAndHandleResponse,
  onDeleteByNumberAndType,
  getLimitTypeUI,
}) => {
  const { t } = useTranslation()
  const { searchQuery, setSearchQuery } = useSearchAndRotation()
  const onSelectBetNumber = (betNumber: string) => {
    const selectedList = betList?.filter((bet) =>
      bet.items.some((item) => item.number === betNumber),
    )
    if (selectedList?.length && selectedList?.length > 0) {
      onDeleteByNumberAndType?.(betNumber, activeBetType)
    } else {
      addLottoListAndHandleResponse?.(betNumber, activeBetType)
    }
  }
  return (
    <div>
      <div>
        <h5 className="text-[var(--caption-text)] text-base font-medium mb-4 text-left">
          {t('betDetailPanel.selectRange')}
        </h5>
      </div>
      <SearchAndRotation
        digitMode={DigitMode.RUNNING}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        isRotated={false}
        isDisabled={true}
      />
      <SelectBetNumber
        activeBetType={activeBetType}
        searchQuery={searchQuery}
        digitMode={DigitMode.RUNNING}
        betList={betList}
        onSelectBetNumber={onSelectBetNumber}
        isDisabled={activeBetType?.length === 0 || !activeBetType}
        getLimitTypeUI={getLimitTypeUI}
      />
    </div>
  )
}

export default RunningPanel
